<template>
  <div>
      <div class="yearSelector selector x-column x-sm mtn x-1-3">
      <h4 class="mtn h4"><span>Tests By</span></h4>
      <ul>
        <li v-for="mode in modes">
        <label :for="mode" class="checkbox-wrapper"><input name="modes[]" v-model="selectedMode" type="radio" :id="mode" class="input-checkbox" :value="mode"> <span class="checkbox"></span> <span class="checkbox-label">{{mode}}</span></label>
        </li>
      </ul>

    </div>

    <div v-if="selectedMode=='competition'"  class="competitionSelector selector x-column x-sm mtn x-1-3">
      <h4 class="mtn h4"><span>Select Competition</span></h4>
      <ul>
        <li v-for="competition in competitions">
        <label :for="competition.slug" class="checkbox-wrapper"><input name="competitions" v-model="selected.competitions" type="radio" :id="competition.slug" class="input-checkbox" :value="competition.slug"> <span class="checkbox"></span> <span class="checkbox-label">{{competition.name}}</span></label>
        </li>
      </ul>
    </div>

    <div v-if="selectedMode=='competition' && !!selected.competitions.length" class="yearSelector selector x-column x-sm mtn x-1-3">
      <h4 class="mtn h4"><span>Select Years</span></h4>
      <ul>
        <li v-for="year in years">
        <label :for="year.slug" class="checkbox-wrapper"><input name="years[]" v-model="selected.years" type="checkbox" :id="year.slug" class="input-checkbox" :value="year.slug"> <span class="checkbox"></span> <span class="checkbox-label">{{year.name}} ({{year.questionsByYear}})</span></label>
        </li>
      </ul>

    </div>

    <div v-if="selectedMode=='topics'" class="topicSelector selector x-column x-sm mtn x-1-3">
      <h4 class="mtn h4"><span>Select Topic</span></h4>
      <ul>
        <li v-for="topic in topics">
        <label :for="topic.slug" class="checkbox-wrapper"><input name="topics[]" v-model="selected.topics" type="checkbox" :id="topic.slug" class="input-checkbox" :value="topic.slug"> <span class="checkbox"></span> <span class="checkbox-label">{{topic.name}}</span></label>
        </li>
      </ul>
    </div>

    <div v-if="selectedMode=='keywords'" class="keywordSelector selector x-column x-sm mtn x-1-3">
      <h4 class="mtn h4"><span>Select Keyword</span></h4>
      <input type="text" name="keyword" v-model="keyword">
      <br>
      <div v-if="keywordCount">
        found {{keywordCount}} questions
      </div>
    </div>

    <button class="button" @click="start()">START</button>
  </div>
</template>

<script>
import _ from 'underscore'

export default {
  name: 'settings',
  mounted : function(){
    var vm = this;

    vm.$http.get('https://biolympiads.com/wp-json/bioquiz/v1/init').then(response => {

        console.log(response);
        vm.years = response.data.years;
        vm.competitions = response.data.competitions;
        vm.topics = response.data.topics;

      }, response => {
        console.error(response);
      });
  },
  data () {
    return {
      years: [],
      competitions: [],
      topics: [],
      modes: ['competition','topics', 'keywords'],
      selectedMode:'competition',
      selected:{
        years:[],
        competitions: [],
        topics: [],
      },
      keyword: '',
      keywordCount: ''
    }
  },
  watch:{

  },
  methods: {
    toggeYear: function(year){
      var vm = this;
      if(!vm.selected.years.includes(year)){
        vm.selected.years.push(year);
      } else {
        let index = vm.selected.years.indexOf(year);
        vm.selected.years.splice(index, 1);
      }
      console.log('amainzg', year);
    },
    getYears: function(){
      var vm = this;
      vm.$http.get('https://biolympiads.com/wp-json/bioquiz/v1/getYears?competition=' + vm.selected.competitions).then(response => {

        vm.years = response.data;

      }, response => {
        console.error(response);
      });
    },
    toggeCompetition: function(competition){
      var vm = this;
      if(!vm.selected.competitions.includes(competition)){
        vm.selected.competitions.push(competition);
      } else {
        let index = vm.selected.competitions.indexOf(competition);
        vm.selected.competitions.splice(index, 1);
      }
      console.log('amainzg', competition);
    },
    toggeTopics: function(topic){
      var vm = this;
      if(!vm.selected.topics.includes(topic)){
        vm.selected.topics.push(topic);
      } else {
        let index = vm.selected.topics.indexOf(topic);
        vm.selected.topics.splice(index, 1);
      }
      console.log('amainzg', topic);
    },
    debounceKeywordInput: _.debounce(function(){
      var vm = this;
      vm.$http.get('https://biolympiads.com/wp-json/bioquiz/v1/getKeywordCount?keyword=' + this.keyword).then(response => {

        vm.keywordCount = response.data;

      }, response => {
        console.error(response);
      });
    }, 200),
    start: function(){
      var vm = this;

      if(vm.selectedMode == 'topics'){
        delete vm.selected.competitions;
        delete vm.selected.years;
        delete vm.selected.keyword;
      }
      else if(vm.selectedMode == 'keywords'){
        delete vm.selected.competitions;
        delete vm.selected.years;
        delete vm.selected.topics;
        vm.selected.keyword = vm.keyword;
      }


      vm.$emit('start', vm.selected);
    }
  },
  watch: {
    changedCompetition: function(){
      var vm = this;
      vm.getYears();
    },
    selectedMode: function(item){
      console.log(item);
      console.log('pasikeite');
      var vm = this;
      vm.selected = {
        years:[],
        competitions: [],
        topics: [],
      };

    },
    keyword: function(keyword){
      var vm = this;
      vm.debounceKeywordInput();
    }
  },
  computed: {
    changedCompetition: function(){
      return this.selected.competitions;
    }
  }
}
</script>

<style lang="scss">
/*.selector {
  width: 300px;
  float: left;
}*/

.yearSelector{
      text-transform: uppercase;
}

.active{
  background: green;
  color:white;
}



.checkbox-wrapper input.input-checkbox {
    display: none
}

.checkbox-wrapper input.input-checkbox:checked+.checkbox {
    background-color: #67b600;
    border-color: #67b600
}

.checkbox-wrapper input.input-checkbox:checked+.checkbox:after {
    border-left: 1px solid #fff;
    border-bottom: 1px solid #fff;
    width: 13px;
    height: 7px;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    position: absolute;
    left: 3px;
    top: 2px;
    display: block;
    content: '';
}
.checkbox-wrapper .checkbox {
    display: inline-block;
    width: 15px;
    height: 15px;
    border: 1px solid #dedede;
    border-radius: 2px;
    background-color: #fff;
    position: relative;
    margin: 0 8px 0 0;
}
ul {
  list-style: none;
}

.checkbox-label {
  cursor: pointer;
}

.pull-right{
  float:right;
}
</style>



// WEBPACK FOOTER //
// Settings.vue?89cce35a